import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ShopCard from "../ShopCard/ShopCard"; // Import the ProductCard component


const PromoProductsSlider = ({ promoProducts, onLearnMore,labels, isFromListing, getTabContent}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const settings = {
        dots: true,        // Show navigation dots
        infinite: true,     // Loop the slider infinitely
        speed: 500,         // Transition speed in milliseconds
        slidesToShow: 1,    // Number of slides to show at a time - Changed to 1 to match the image
        slidesToScroll: 1,  // Number of slides to scroll at a time
        adaptiveHeight: true, // Adjust slider height based on content  - Added for dynamic height
        afterChange: current => setCurrentIndex(current),
        responsive: [       // Responsive settings
            {
                breakpoint: 1024, // Adjust breakpoint as needed
                settings: {
                    slidesToShow: 1  // Show 1 slide at a time on larger screens
                }
            },
            {
                breakpoint: 768, // Adjust breakpoint as needed
                settings: {
                    slidesToShow: 1 // Show 1 slide at a time on medium screens
                }
            },
            {
                breakpoint: 600,  // Adjust breakpoint as needed
                settings: {
                    slidesToShow: 1  // Show 1 slide at a time on smaller screens
                }
            }
        ]
    };


    if (!promoProducts || !promoProducts.items || promoProducts.items.length === 0) {
        return null;
    }
    return (
        <div  style = {{maxWidth:"320px"}}>
            <div className="promotional-product-slider">
                <Slider {...settings}>
                    {promoProducts?.items.map((item, index) => {
                        const componentProps = getTabContent(item, onLearnMore, labels, isFromListing);
                        return (
                            <div
                                key={index}
                                className={`main-card-container products-grid-card-container`}
                            >
                                <ShopCard  {...componentProps} />
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </div>

    );
};


export default PromoProductsSlider;